import React from 'react'

const ShippingOne = () => {
    return (
        <section className="shipping mb-24" id="shipping">
            <div className="container container-lg">
                <div className="row g-3 g-lg-4">
                    <div className="col-12 col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="shipping-item hover-lift flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2 h-100">
                            <span className="shipping-item__icon w-44 h-44 flex-center rounded-circle bg-main-600 text-white text-2xl flex-shrink-0">
                                <i className="ph-fill ph-car-profile" />
                            </span>
                            <div className="shipping-item__content">
                                <h6 className="mb-0 text-md shipping-item__title">Free Shipping</h6>
                                <span className="text-xs text-heading d-block shipping-item__desc">
                                    On eligible orders
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
                        <div className="shipping-item hover-lift flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2 h-100">
                            <span className="shipping-item__icon w-44 h-44 flex-center rounded-circle bg-main-600 text-white text-2xl flex-shrink-0">
                                <i className="ph-fill ph-hand-heart" />
                            </span>
                            <div className="shipping-item__content">
                                <h6 className="mb-0 text-md shipping-item__title">100% Natural</h6>
                                <span className="text-xs text-heading d-block shipping-item__desc">
                                    Pure &amp; unrefined
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="shipping-item hover-lift flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2 h-100">
                            <span className="shipping-item__icon w-44 h-44 flex-center rounded-circle bg-main-600 text-white text-2xl flex-shrink-0">
                                <i className="ph-fill ph-credit-card" />
                            </span>
                            <div className="shipping-item__content">
                                <h6 className="mb-0 text-md shipping-item__title">Secure Payments</h6>
                                <span className="text-xs text-heading d-block shipping-item__desc">
                                    UPI, Cards &amp; NetBanking
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
                        <div className="shipping-item hover-lift flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2 h-100">
                            <span className="shipping-item__icon w-44 h-44 flex-center rounded-circle bg-main-600 text-white text-2xl flex-shrink-0">
                                <i className="ph-fill ph-chats" />
                            </span>
                            <div className="shipping-item__content">
                                <h6 className="mb-0 text-md shipping-item__title">Dedicated Support</h6>
                                <span className="text-xs text-heading d-block shipping-item__desc">
                                    WhatsApp &amp; Phone
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default ShippingOne
